import { lazy } from "react";

import { PageAtRouteMap } from "@/pages/pages.types";

export * from "@/pages/pages.types";

/**
 * Define Pages as a lazy loaded component from thier folders
 */
export const AdministrationPage = lazy(() => import("@/pages/AdministrationPage"));
export const OfficeMapPage = lazy(() => import("@/pages/OfficeMapPage"));
export const NavPointManagementPage = lazy(() => import("@/pages/NavPointManagementPage"));

/**
 * Create an object where routes are associated the their page components
 */
export const pageAtRouteMap = {
    administration: AdministrationPage,
    officeMap: OfficeMapPage,
    navPointManagement: NavPointManagementPage,
} satisfies Partial<PageAtRouteMap>;
